import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { FrontendComponent } from "./frontend.component";
import { Page404Component } from "./page404.component";

const routes: Routes = [
  {
    path: "",
    component: FrontendComponent,
    children: [
      { path: "", loadChildren: "./inicio/inicio.module#InicioModule" },
      {
        path: "libreria",
        loadChildren: "./libreria/listado/listado.module#LibreriaListadoModule",
      },
      {
        path: "libreria/:aliasLibro",
        loadChildren: "./libreria/detalle/detalle.module#LibreriaDetalleModule",
      },
      {
        path: "pdf",
        loadChildren: "./pdf/pdf.module#PdfModule",
      },
      {
        path: "biblioteca",
        loadChildren:
          "./biblioteca/biblioteca-f.module#BibliotecaListadoModule",
      },
      { path: "blog", loadChildren: "./blog/blog.module#FrontBlogModule" },
      {
        path: "contactenos",
        loadChildren: "./contactenos/contactenos.module#ContactenosModule",
      },
      {
        path: "login",
        loadChildren: "./login/login-f.module#FrontLoginModule",
      },
      {
        path: "profile",
        loadChildren: "./profile/profile.module#ProfileModule",
      },

      { path: "404", component: Page404Component },

      { path: "", redirectTo: "/", pathMatch: "full" },
    ],
  },
  { path: "**", redirectTo: "/404", pathMatch: "full" },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FrontendRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/modules/frontend/frontend.routing.ts